<div [appStoryblok]="_editable" class="container-xl py-3">
  <h4 class="py-3 mb-0">From the Journal</h4>
  <div class="row border-top py-4 gx-0" *ngFor="let entry of _articles">
    <div class="col-lg-5 col-12">
      <div class="justify-content-center flex-column h-100 d-flex">
        <div class="article-content">
          <div *ngIf="entry?.type" class="eyebrow">
            {{ entry.type }}
          </div>
          <h2 *ngIf="entry?.name">{{ entry.name }}</h2>
          <div
            *ngIf="entry?.content?.excerpt"
            class="excerpt"
            [storyblokRichText]="entry.content.excerpt"
          ></div>
        </div>
        <div class="flex-row mt-5 mb-5 mb-lg-0">
          <a [storyblokLink]="entry" class="btn btn-lg btn-outline-dark"
            >Read Article</a
          >
        </div>
      </div>
    </div>
    <div class="col-lg-3 ms-auto col-12">
      <img
        class="w-100"
        height="463"
        width="328"
        [ngSrc]="entry?.content?.teaser?.filename"
        *ngIf="entry?.content?.teaser?.filename"
      />
    </div>
  </div>
</div>
